import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { useIntl } from '../providers';
import { Button, IconButton } from './Buttons';
import { CancelIcon } from './Icons';

interface OrderAsAlwaysProps {
    enabled: boolean;
    onClick: () => void;
}

const useStyles = createUseStyles({
    orderAsAlways: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '2rem',
        padding: '1rem',
        border: '2px solid var(--secondary-color)',
        justifyContent: 'space-between',
        '& > p': {
            flex: 1,
            '@media (min-width: 640px)': {
                marginRight: '5rem',
            },
        },
        '& > button': {
            flex: 0,
            display: 'flex',
            alignSelf: 'center',
            height: 'min-content',
            '@media (min-width: 640px)': {
                whiteSpace: 'nowrap',
            },
        },
    },
    orderAsAlwaysButton: {
        padding: '.3rem .5rem',
    },
    cancelOrderAsAlwaysButton: {
        padding: 0,
        border: 0,
    },
});

const OrderAsAlways: React.FC<OrderAsAlwaysProps> = ({ enabled, onClick }: OrderAsAlwaysProps) => {
    const classes = useStyles();
    const { translate } = useIntl();

    return (
        <div className={classes.orderAsAlways}>
            {enabled ? (
                <React.Fragment>
                    <p>{translate('orderForm.action.orderAsAlways', 'Order as always')}</p>
                    <IconButton
                        onClick={onClick}
                        className={classes.cancelOrderAsAlwaysButton}
                        title={translate('orderForm.action.cancelOrderAsAlways', 'New order')}
                    >
                        <CancelIcon size={25} stroke="var(--secondary-color)" />
                    </IconButton>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <p>
                        {translate(
                            'orderForm.label.orderAsAlways',
                            'Already a customer and ordering the same article?'
                        )}
                    </p>
                    <Button
                        onClick={onClick}
                        className={classes.orderAsAlwaysButton}
                        label={translate('orderForm.action.orderAsAlways', 'Order as always')}
                    />
                </React.Fragment>
            )}
        </div>
    );
};

export default React.memo(OrderAsAlways);
